<section>
  <hgroup>
    <h3>UML version text</h3>
    <p>utile pour copier/coller dans un outil comme LucidChart</p>
  </hgroup>
  @if (javaClass()) {
    <ul>
      @for (modifier of javaClass().classModifier; track $index) {
        <li>{{ modifier }}</li>
      }
      <li>{{ javaClass().className }}</li>
      <ul>
        @for (field of javaClass().fields; track $index) {
          <li>{{ field }}</li>
        }
      </ul>
      <ul>
        @for (method of javaClass().methods; track $index) {
          <li>{{ method }}</li>
        }
      </ul>
    </ul>
  }
</section>
<section>
  <hgroup>
    <h3>UML version dessin</h3>
    <p>utile pour visualiser</p>
  </hgroup>
  <app-uml-canvas></app-uml-canvas>
</section>
